// This component handles the "one-click login" process.
import React, { useEffect } from "react";
import Cookies from "universal-cookie";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../utils/loader";
import { getOneClickLoginUserCheck, postUpdateProfile } from "../../../store/slices/Registration/CommonSlices";
import { certificationPage, setCookiesAndRedirectionOnLogin } from "../../utils/registrationUtils";
import {logoutUser} from "../../../store/slices/user/index";

function OneClickLogin(props) {
  const cookies = new Cookies();
  const destinationDomain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME;
  let date = new Date();
  const dispatch = useDispatch();
  const { oneClickLoginUserCheck: oneClickLoginUserChecks, updateProfile: updateProfileData, oneClickLoginUserCheckError: oneClickLoginUserCheckError } = useSelector((state) => state.usersCommonData);
  const { loading, user, userLogout : userLogout } = useSelector((state) => state.userData);

  // to check the page is for certification domain
  const urlCheck = window.location.href;
  let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
    window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
  const urlParams = new URLSearchParams(location.search);
  // needs to delete some params for saving purpose hence intialized again.
  const searchParams = new URLSearchParams(window.location.search);

  // Delete 'uid' and 'uuid' if they exist
  searchParams.delete('uid');
  searchParams.delete('uuid');
  searchParams.delete('destination');
  const updatedQueryString = searchParams.toString();

  // Extract URL parameters
  const userUuid = urlParams.get('uuid');
  const userUid = urlParams.get('uid');
  const sourceUrl = urlParams.get('url_source');
  const formType = urlParams.get('form_type');
  const destinationParam = urlParams.get('destination');

  // Call function on mount.
  useEffect(() => {
    setUrlParams();
  }, [])
  useEffect(() => {
    if(userLogout && oneClickLoginUserChecks && !oneClickLoginUserChecks?.ask_mobile_verify && !oneClickLoginUserChecks?.ask_update_profile 
      && !oneClickLoginUserChecks?.ask_complete_profile ){
        postUpdateProfileDataOnLoad();
    }
  }, [userLogout, oneClickLoginUserChecks]);

  useEffect(() => {
    if(oneClickLoginUserChecks && !!cookies.get("c360_jwt_access")){
      dispatch(logoutUser());
    }
    if(oneClickLoginUserCheckError){
      window.location.href = destinationParam;
      cookies.remove("one-click-login", {
        path: "/",
        domain: destinationDomain,
      });
      cookies.remove("mv_status", {
        path: "/",
        domain: destinationDomain,
      });
      cookies.remove("up_status", {
        path: "/",
        domain: destinationDomain,
      });
      localStorage.removeItem("stored_user_uuid"); // to modify latest uuid

    }
    if(!cookies.get("c360_jwt_access") && oneClickLoginUserChecks && !oneClickLoginUserChecks?.ask_mobile_verify && !oneClickLoginUserChecks?.ask_update_profile 
      && !oneClickLoginUserChecks?.ask_complete_profile ){
        postUpdateProfileDataOnLoad();
    }
    if(oneClickLoginUserChecks && oneClickLoginUserChecks?.ask_complete_profile && oneClickLoginUserChecks?.ask_mobile_verify){
      let obj = cookies.get("one-click-login") || { data: {} };

    // Update obj.data with URL parameters
    obj.data = {
      ...obj.data,
      ask_mobile_verify: true,
    };
    // Set the cookie with the updated object
    cookies.set("one-click-login", obj, {
      path: "/",
      domain: window.location.origin?.includes('localhost') ? "localhost" : destinationDomain,
      expires: new Date(date.setDate(date.getDate() + 1)),
      sameSite: "Lax",
    });
    }
    // Redirect if destination param is found
    if (destinationParam && oneClickLoginUserChecks && (oneClickLoginUserChecks?.ask_mobile_verify 
      || oneClickLoginUserChecks?.ask_update_profile || oneClickLoginUserChecks?.ask_complete_profile)) {
      window.location.href = `${destinationParam}?${updatedQueryString}`;
    }
  },[oneClickLoginUserChecks, oneClickLoginUserCheckError])

  useEffect(() => {
    if(!updateProfileData?.ask_update_profile && updateProfileData?.cookies && updateProfileData?.proceed){
      setCookiesAndRedirectionOnLogin(updateProfileData);
    }
    if(updateProfileData?.ask_update_profile && updateProfileData?.required_field?.length > 0){
      window.location.href = `${destinationParam}?${updatedQueryString}`;
    }
  },[updateProfileData])

  // Function to handle URL parameters, setting cookies, and making API calls
  const setUrlParams = () => {

    // Get the existing cookie data or initialize as an empty object
    let obj = cookies.get("one-click-login") || { data: {} };

    // Update obj.data with URL parameters
    obj.data = {
      ...obj.data,
      urlParam: updatedQueryString,
    };

    // Conditionally add uuid if userUuid is present
    if (userUuid) {
      obj.data.uuid = userUuid;
    }

    // Conditionally add uid if userUid is present
    if (userUid) {
      obj.data.uid = userUid;
    }

    // Set the cookie with the updated object
    cookies.set("one-click-login", obj, {
      path: "/",
      domain: window.location.origin?.includes('localhost') ? "localhost" : destinationDomain,
      expires: new Date(date.setDate(date.getDate() + 1)),
      sameSite: "Lax",
    });

    // Prepare params for the API call
    const params = {
      ...(userUuid && { user_uuid: userUuid }),
      ...(userUid && { user_id: userUid }),
      ...(sourceUrl && { url_source: sourceUrl }),
      ...(formType && { form_type: formType }),
    };
    params.current_url =  `${destinationParam}?${updatedQueryString}`;
    dispatch(getOneClickLoginUserCheck(params));
  };
    // Profile update API call on load
    const postUpdateProfileDataOnLoad = () => { //profile update api call if update profile case is true in login api and onload
      let params = {};
      params.current_url =  `${destinationParam}?${updatedQueryString}`;
      params.page_url = `${destinationParam}?${updatedQueryString}`;
      params.destination = `${destinationParam}?${updatedQueryString}`;
      params.cta_clicked = "one-click";
      params.certification = certificationFormCheck ? true : false;
      params.user_id = userUid;
      params.submit = true;
      params.via_oneclick = 1;
      dispatch(postUpdateProfile(params));
    }

  return (
    <>
      {/* loader */}
      <div className="text-center">
        <Loading colour={"FFA500"} size={100} />
      </div>
    </>);

}
export default OneClickLogin;
